import { Dropdown, Menu } from 'antd';
import SubMenu from 'antd/lib/menu/SubMenu';
import cx from 'classnames';
import React from 'react';
import { ColumnsProps } from '../../../Helper';
import { SelectOptions } from '../../../model/CommonModel';
import { MoveCredential, WhosInsideCredentialDataType, ZoneGroupTree } from '../../../model/WhosInsideModel';
import { WhosInsideMoveTo } from '../../whosInside';
import styles from './whosInsideHelperElements.module.scss';

type WhosInsideCellProps<DataType> = {
	isTableInEditMode: boolean;
	record: DataType;
	children?: React.ReactNode;
	options?: SelectOptions<DataType>[];
	onClickOption?: (value: DataType, moveCredentialInfo?: Partial<MoveCredential>) => void;
	onChangeSelection?: (value: DataType) => void;
	selectedCredentials?: number;
	storedZoneGroupTree?: ZoneGroupTree;
} & React.HTMLAttributes<HTMLElement>;

const WhosInsideCell = ({
	isTableInEditMode,
	record,
	children,
	options,
	onClickOption,
	onChangeSelection,
	selectedCredentials,
	storedZoneGroupTree,
	...restProps
}: WhosInsideCellProps<ColumnsProps<WhosInsideCredentialDataType>>) => {
	let content: JSX.Element;
	if (!isTableInEditMode && options) {
		const menu = (
			<Menu getPopupContainer={(element: HTMLElement) => element.closest('.ant-table-body')}>
				{options.map(({ label, disabled, title, id, separator, value }, index) => {
					if (label === _('MoveTo')) {
						const titleElement = <span title={title}>{label}</span>;
						return (
							<SubMenu key={`${label}-${selectedCredentials}-${index}`} disabled={disabled} title={titleElement}>
								<Menu.Item key={`${label}-${index}`} disabled={true} className={styles.moveToMenuItem}>
									<WhosInsideMoveTo actionValue={value} onClickOption={onClickOption} storedZoneGroupTree={storedZoneGroupTree} />
								</Menu.Item>
							</SubMenu>
						);
					} else {
						return (
							<Menu.Item
								id={id}
								key={`${label}-${index}`}
								onClick={() => onClickOption?.(value)}
								className={cx({ [styles.separator]: separator })}
								disabled={disabled}
								title={title}>
								{label}
							</Menu.Item>
						);
					}
				})}
			</Menu>
		);

		content = (
			<Dropdown
				getPopupContainer={(element: HTMLElement) => element.closest('.ant-table-body')}
				overlay={menu}
				trigger={['contextMenu']}
				onVisibleChange={visible => {
					if (visible) {
						onChangeSelection?.(record);
					}
				}}
				destroyPopupOnHide>
				<td {...restProps}>{children}</td>
			</Dropdown>
		);
	} else {
		content = <td {...restProps}>{children}</td>;
	}

	return content;
};

export { WhosInsideCell };
